import { BaseService } from "./baseService";

class CommonDataService extends BaseService {

    /**
     * @param $http
     */
    constructor($http) {
        super($http);
        let self = this;

        this.search = function(entity, term) {
            return self.$http({
                method: 'GET',
                url: this.getRoot() + '/hinting/' + entity + '/' + term.replace(/[#.\\\/]/gi, ''),
                headers: {
                    'Content-Type': 'application/json',
                    'authentication': localStorage.getItem('kes_token'),
                },
                data: {}
            });
        };
    }
}

export default CommonDataService;


// WEBPACK FOOTER //
// ./src/app/services/commonDataService.js